/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Missing_BodyInputs */

const en_services_missing_body = /** @type {(inputs: Services_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That page is not here. The sessions on offer are on the list.`)
};

const pl_services_missing_body = /** @type {(inputs: Services_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tej strony tu nie ma. Wszystkie zajęcia znajdziesz na liście.`)
};

/**
* | output |
* | --- |
* | "That page is not here. The sessions on offer are on the list." |
*
* @param {Services_Missing_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_missing_body = /** @type {((inputs?: Services_Missing_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Missing_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_missing_body(inputs)
	return en_services_missing_body(inputs)
});